import axios from "axios";
import { server } from "../../store";

export const getCategory = (id) => async (dispatch) => {

    try {

        dispatch({
            type: "getCategoryRequest"
        })

        const config = {

            headers: { "Content-Type": "application/json" },

        };


        const { data } = await axios.get(
            `${server}/category/${id}`,
            config
        );

        dispatch({
            type: "getCategorySuccess",
            payload: data
        })


    } catch (error) {
        dispatch({
            type: "getCategoryFail",
            payload: error.response.data.message
        })
    }
}


export const getAllCategories = () => async (dispatch) => {

    try {

        dispatch({
            type: "getAllCategoryRequest"
        })

        const config = {
            headers: {
                "Content-Type": "application/json"
            },
        }

        const { data } = await axios.get(`${server}/categories/all`, config)


        dispatch({
            type: "getAllCategorySuccess",
            payload: data
        })


    } catch (error) {
        dispatch({
            type: "getAllCategorysFail",
            payload: error.response.data.message
        })
    }
}